import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import { Stack } from '@etg/wings';
import { resolveDeepLinkToBooking } from '../../../../common/deeplinking/booking';
import PartnerBanner from '../../../../common/components/PartnerBanner';
import { useOrderDetails } from '../../containers/OrderDetailsContext';

export interface HotelsAndCarsProps {
  className?: string;
  dataTestIdPrefix: string;
}

const HotelsAndCars = ({ className, dataTestIdPrefix }: HotelsAndCarsProps) => {
  const { siteCurrency, language } = useSiteContext();
  const { t } = useTranslation();
  const { p } = useProperty();
  const { bounds, travelers } = useOrderDetails();

  const isHotelsBannerEnabled = p('OrderDetails.Overview.Banner.Hotels.Enabled');
  const isCarsBannerEnabled = p('OrderDetails.Overview.Banner.Cars.Enabled');
  const carUrl = p('Order.CarModal.Url');
  const hotelUrl = resolveDeepLinkToBooking(
    bounds,
    language.code,
    siteCurrency.code,
    travelers,
    'my_portal',
  );

  return (
    <Stack className={className}>
      {isHotelsBannerEnabled && (
        <PartnerBanner
          data-testid={`${dataTestIdPrefix}-hotel-banner`}
          description={t('MyBookingsWelcomePage.Banner.Hotel.Description')}
          iconName="hotel-banner-illustration"
          partnerLogoId="booking"
          partnerUrl={hotelUrl}
          snowplowEventData={{
            category: 'Order Details',
            action: 'Click',
            label: 'HOTEL_BANNER_LINK',
          }}
          title={t('MyBookingsWelcomePage.Banner.Hotel.Title')}
        />
      )}
      {isCarsBannerEnabled && carUrl && (
        <PartnerBanner
          data-testid={`${dataTestIdPrefix}-car-banner`}
          description={t('MyBookingsWelcomePage.Banner.Car.Description')}
          iconName="car-banner-illustration"
          partnerLogoId="rentalcars"
          partnerUrl={carUrl}
          snowplowEventData={{
            category: 'Order Details',
            action: 'Click',
            label: 'CAR_BANNER_LINK',
          }}
          title={t('MyBookingsWelcomePage.Banner.Car.Title')}
        />
      )}
    </Stack>
  );
};

export default HotelsAndCars;
